import React, { createContext, useContext, useReducer } from 'react'

const AccordionStateContext = createContext(undefined)
const AccordionDispatchContext = createContext(undefined)

const accordionReducer = (state) => {
  return { ...state, open: !state.open }
}

export const AccordionProvider = ({
  open,
  shouldAnimate,
  shouldMapOpenPropToContent,
  children,
}: IAccordionProvider) => {
  const [state, dispatch] = useReducer(accordionReducer, {
    open,
    shouldAnimate,
    shouldMapOpenPropToContent,
  })

  return (
    <AccordionStateContext.Provider value={state}>
      <AccordionDispatchContext.Provider value={dispatch}>{children}</AccordionDispatchContext.Provider>
    </AccordionStateContext.Provider>
  )
}

interface IAccordionProvider {
  children: React.ReactNode
  open: boolean
  shouldAnimate: boolean
  shouldMapOpenPropToContent: boolean
}

type AccordianState = {
  open: boolean
  shouldAnimate: boolean
  shouldMapOpenPropToContent: boolean
}

export const useAccordionState = (): AccordianState => {
  const context = useContext(AccordionStateContext)

  if (context === undefined) {
    throw new Error('useAccordionState must be used within a AccordionProvider')
  }

  return context as AccordianState
}

export const useAccordionDispatch = () => {
  const context = useContext(AccordionDispatchContext)

  if (context === undefined) {
    throw new Error('useAccordionDispatch must be used within a AccordionProvider')
  }

  return context
}
